import { connect } from 'react-redux'
import NavBar from './NavBar'

const mapDispatchToProps = {}

const mapStateToProps = state => {
  const { subroute, location, modal, navBar, strings } = state

  return {
    strings,
    location,
    modal,
    subroute,
    showNavLinks:
      subroute !== 'studies' && subroute !== 'users' && subroute !== 'audit',
    navProps: navBar,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NavBar)



// WEBPACK FOOTER //
// ./src/layouts/NavBar/index.js